const locale = require('./submissionActionUtil.i18n.json');

/*@ngInject*/
const SubmissionActionUtil = function ($rootScope, $state, $uibModal, formViewerConstant,
                                       submissionConstant, actionsMediator, submissionMediator, coreMediator, coreConstant,
                                       declineMediator, markAsLostMediator, uiPerformanceLoggerConstant, modalUtil, umModalUtil, loadingBarHandler,
                                       submissionStateMediator, submissionCopyOptions, reportMediator, proposalActionsMediator,
                                       submissionPrequalificationMediator, currentSubmissionModel, agentQuoteStatus, appTypeConfigurationModel) {

    this.i18n = locale;

    this.handleReviewModifications = function (submission) {
        $uibModal.open({
            templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
            controller: 'reviewChangesModalController',
            backdrop: 'static',
            windowClass: 'reviewChangesModal',
            resolve: {
                submission: () => {
                    return submission;
                },
                options: () => {
                    return {
                        title: this.i18n.reviewTitle,
                        isReadOnly: true,
                        changeSetId: submission.changeSetId
                    };
                }
            }
        });
    };

    this.handleSubmitModifications = function (submission) {
        $uibModal.open({
            templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
            controller: 'reviewChangesModalController',
            backdrop: 'static',
            windowClass: 'reviewChangesModal',
            resolve: {
                options: () => {
                    return {
                        title: _.get(this.i18n, 'reviewSubmitTitle'),
                        isReadOnly: false,
                        continueButtonLabel: _.get(this.i18n, 'submitChanges'),
                        continueButtonAction: actionsMediator.submitModifications,
                        changeSetId: submission.changeSetId,
                        loadingBarMessage : _.get(this.i18n, 'submitChangesLoadingBarMessage'),
                        entityId: submission.id
                    };
                }
            }
        });
    };

    this.handleDiscardModifications = function (submission) {
        const title = _.get(this.i18n, 'reviewDiscardTitle'),
            buttonLabel = _.get(this.i18n, 'discardChanges'),
            loadingBarMessageDiscard = _.get(this.i18n, 'discardChangesLoadingBarMessage');

        function getActiveChanges() {
            submissionMediator.loadChangeSet(submission.changeSetId, true).then(function (result) {
                const changeSetList = result.changeList,
                    hasChanges = changeSetList.length > 0;

                if (hasChanges) {
                    showModal();
                }
                else {
                    actionsMediator.discardModifications(submission.id).then(function () {
                        // we send them to the overview screen after we cancel the submission because
                        // the forms are still the same, making sure to refresh the form id, since the
                        // Submission form on the overview is now deleted and recreated as well.
                        $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW, true /*refreshFormId*/);
                    });
                }
            });
        }

        function showModal(hasChanges) {
            $uibModal.open({
                templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
                controller: 'reviewChangesModalController',
                backdrop: 'static',
                windowClass: 'reviewChangesModal',
                resolve: {
                    submission: () => {
                        return submission;
                    },
                    options: () => {
                        return {
                            title: title,
                            isReadOnly: false,
                            continueButtonLabel: buttonLabel,
                            continueButtonAction: actionsMediator.discardModifications,
                            changeSetId: submission.changeSetId,
                            loadingBarMessage: loadingBarMessageDiscard,
                            entityId: submission.id,
                            hasChanges: hasChanges
                        };
                    }
                }
            });
        }

        getActiveChanges();
    };

    this.handleAcknowledgeModifications = function (submission) {
        const title = _.get(this.i18n, 'reviewAcknowledgeTitle'),
            buttonLabel = _.get(this.i18n, 'acknowledgeChanges');

        function getActiveChanges() {
            submissionMediator.loadChangeSet(submission.changeSetId, true).then(function (result) {
                const changeSetList = result.changeList,
                    hasChanges = changeSetList.length > 0;

                if (hasChanges) {
                    showModal();
                } else {
                    actionsMediator.acknowledgeModifications(submission.id).then(function () {
                        $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW, true /*refreshFormId*/);
                    });
                }
            });
        }

        function showModal(hasChanges) {
            $uibModal.open({
                templateUrl: '/modification/reviewChanges/reviewChangesModal.tpl.html',
                controller: 'reviewChangesModalController',
                backdrop: 'static',
                windowClass: 'reviewChangesModal',
                resolve: {
                    submission: () => {
                        return submission;
                    },
                    options: () => {
                        return {
                            title: title,
                            isReadOnly: false,
                            continueButtonLabel: buttonLabel,
                            continueButtonAction: actionsMediator.acknowledgeModifications,
                            changeSetId: submission.changeSetId,
                            entityId: submission.id,
                            hasChanges: hasChanges,
                            navigateToOverviewBeforeContinue: true
                        };
                    }
                }
            });
        }

        getActiveChanges();
    };


    this.getQuotableProductTemplates = function (submissionId) {
        function onSuccess(response) {
            if (response.length === 1) {
                createProposal(submissionId, [response[0].id]);
            } else if (response.length > 1) {
                const isProposalAction = currentSubmissionModel.getCurrentSubmission().agentQuoteStatus !== agentQuoteStatus.ENABLED,
                    modalInstance = $uibModal.open({
                        templateUrl: '/wizard/quotableProductTemplates/quotableProductTemplatesModal.tpl.html',
                        controller: 'quotableProductTemplatesModalController',
                        backdrop: 'static',
                        windowClass: 'quotableProductModal',
                        resolve: {
                            options: function () {
                                return {
                                    quotableProducts: response,
                                    isProposalAction: isProposalAction
                                };
                            }
                        }
                    });

                modalInstance.result.then(function (options) {
                    if (isProposalAction) {
                        createProposal(submissionId, options.selectedQuotableProductIds);
                    } else {
                        createQuote(submissionId, options.selectedQuotableProductId);
                    }
                });
            }
        }

        let promise = actionsMediator.getQuotableProductTemplates(submissionId).then(onSuccess);

        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    };

    this.splitSubmission = function (submissionId) {
        const submission = submissionMediator.getSubmissionById(submissionId),
            productShortNames = submission.productShortNames,
            modalInstance = $uibModal.open({
                templateUrl: '/wizard/splitSubmission/splitSubmissionModal.tpl.html',
                controller: 'splitSubmissionModalController',
                backdrop: 'static',
                windowClass: 'splitSubmissionModal',
                resolve: {
                    options: function () {
                        return {
                            productShortNames: productShortNames,
                            submissionId: submissionId
                        };
                    }
                }
            });

        modalInstance.result.then(function (response) {
            const logAction = uiPerformanceLoggerConstant.SPLIT_SUBMISSION,
                message = submissionId.toString();

            function onSuccess(response) {
                submissionMediator.loadSubmission(response.id).then(function (submission) {
                    loadingBarHandler.hideLoadingBar();
                    submissionMediator.setCurrentSubmission(submission);
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
                    $state.go('submission.form', {submissionId: submission.id});
                });
            }

            function onError() {
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
            }

            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
            loadingBarHandler.showLoadingBar('submission.wizard.splitSubmissionModal.loadingBar');
            actionsMediator.splitSubmission(submissionId, response.productShortNames).then(onSuccess, onError);
        });
    };

    function createProposal(submissionId, selectedQuotableProductId) {
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_PROPOSAL, submissionId);
        loadingBarHandler.showLoadingBar('submission.wizard.quotableProductModal.loadingBarForProposal');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        let onSuccess = () => {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_PROPOSAL, coreConstant.uiPeformanceLogger.SUCCESS);
        };
        let onFailure = () => {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.CREATE_PROPOSAL, coreConstant.uiPeformanceLogger.FAIL);
        };
        let promise = proposalActionsMediator.createProposal(submissionId, selectedQuotableProductId).then(onSuccess, onFailure);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    }

    function createQuote(submissionId, selectedQuotableProductId) {
        loadingBarHandler.showLoadingBar('submission.wizard.quotableProductModal.loadingBar');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        let promise = actionsMediator.createQuote(submissionId, selectedQuotableProductId).then(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    }

    this.handleCopySubmission = function (submissionId) {
        const modalInstance = $uibModal.open({
            templateUrl: '/wizard/copySubmission/copySubmissionModal.tpl.html',
            controller: 'copySubmissionModalController',
            backdrop: 'static',
            windowClass: 'copySubmissionModal'
        });

        modalInstance.result.then((response) => {
            const logAction = uiPerformanceLoggerConstant.COPY_SUBMISSION,
                message = `${submissionId} - ${response.copyOptions}`;

            function onSuccess(response) {
                submissionMediator.loadSubmission(response.id).then(function (submission) {
                    loadingBarHandler.hideLoadingBar();
                    submissionMediator.setCurrentSubmission(submission);
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
                });
            }

            function onError() {
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
            }

            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
            loadingBarHandler.showLoadingBar(this.i18n.copySubmission.loadingBar);
            actionsMediator.copySubmission(submissionId, response.copyOptions).then(onSuccess, onError);
        });
    };

    this.handleReactivate = function (submissionId) {
        modalUtil.showConfirmationModal(submissionId, null/*quoteId*/, null/*notificationName*/, 'submission.wizard.reasonModal.reactivateModal',
            null/*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            let promise = actionsMediator.reactivate(submissionId);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.handleReevaluate = function (submissionId) {
        modalUtil.showConfirmationModal(submissionId, null/*quoteId*/, null/*notificationName*/, 'submission.wizard.reasonModal.reevaluateModal',
            null/*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            let promise = actionsMediator.reevaluate(submissionId);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.handleMarkSubmissionAsLost = function (submission) {
        function confirmActionCallback(submissionId) {
            let promise = actionsMediator.markAsLost(submissionId);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        function cancelActionCallback(submissionId) {
            return markAsLostMediator.deleteMarkAsLostForm(submissionId);
        }

        markAsLostMediator.createMarkAsLostForm(submission.id).then((markAsLostFormId) => {
            umModalUtil.showReasonFormModal(submission, markAsLostFormId, confirmActionCallback, cancelActionCallback, 'markAsLost', uiPerformanceLoggerConstant.MARK_AS_LOST);
        });
    };

    this.handleReject = function (submissionId) {
        umModalUtil.showReasonModal(submissionId, null/*quoteId*/, 'notification.reject', null /*reason*/, 'submission.wizard.reasonModal.rejectModal', false,
            null/*performanceLoggerName*/, handleClose);

        function handleClose(result) {
            let promise = actionsMediator.reject(submissionId, result.reason, result.details);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.handleDecline = function (submission) {
        function confirmActionCallback(submissionId) {
            let promise = actionsMediator.decline(submissionId);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }

        function cancelActionCallback(submissionId) {
            return declineMediator.deleteDeclinationForm(submissionId);
        }

        declineMediator.createDeclinationForm(submission.id).then((declinationFormId) => {
            umModalUtil.showReasonFormModal(submission, declinationFormId, confirmActionCallback, cancelActionCallback, 'decline', uiPerformanceLoggerConstant.DECLINE_SUBMISSION);
        });
    };

    this.handleNotClear = function (submissionId) {
        umModalUtil.showReasonModal(submissionId, null/*quoteId*/, null/*notificationName*/, null /*reason*/, 'submission.wizard.reasonModal.notClearModal',
            false, null/*performanceLoggerName*/, handleClose);

        function handleClose(result) {
            let promise = actionsMediator.markSubmissionNotClear(submissionId, result.reason, result.details);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.handleClearReady = function (submissionId) {
        umModalUtil.showReasonModal(submissionId, null/*quoteId*/, null, null /*reason*/, 'submission.wizard.reasonModal.clearReadyModal',
            true, uiPerformanceLoggerConstant.CLEAR_READY_SUBMISSION, handleClose);

        function handleClose(result) {
            let promise = actionsMediator.markSubmissionClearReady(submissionId, result.reason, result.details);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.handleRevertToClear = function (submissionId) {
        modalUtil.showConfirmationModal(submissionId, null/*quoteId*/, null /*notificationName*/, 'submission.wizard.reasonModal.revertToClear',
            uiPerformanceLoggerConstant.REVERT_TO_CLEAR, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            let promise = actionsMediator.revertToClear(submissionId);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.handleCheckClearance = function (submissionId) {
        let promise,
            onSuccess = (response) => {
                let options = {};

                if (response.value === 3 /*unknown*/) {
                    options.title = response.reason;
                    options.summary = response.detail;
                }
                else if (response.value === 2 /*Not Clear*/) {
                    options.title = _.get(this.i18n, 'checkClearance.notClear.title');
                    options.summary = _.get(this.i18n, 'checkClearance.notClear.summary');
                }
                else if (response.value === 1 /*Clear*/) {
                    options.title = _.get(this.i18n, 'checkClearance.clear.title');
                    options.summary = _.get(this.i18n, 'checkClearance.clear.summary');
                }
                options.cancelButtonLabel = _.get(this.i18n, 'alert.okButtonLabel');

                $uibModal.open({
                    templateUrl: '/ui/modal/modal.tpl.html',
                    controller: 'modalController',
                    backdrop: 'static',
                    windowClass: 'genericModal',
                    resolve: {
                        options: () => {
                            return options;
                        }
                    }
                });
            };

        promise = actionsMediator.handleCheckClearance(submissionId).then(onSuccess);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    };

    this.handleClear = function (submissionId) {
        modalUtil.showConfirmationModal(submissionId, null/*quoteId*/, null/*notificationName*/, 'submission.wizard.reasonModal.clearModal',
            uiPerformanceLoggerConstant.CLEAR_SUBMISSION, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            let promise = actionsMediator.markSubmissionClear(submissionId);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.changeProducts = function (submissionId) {
        const submission = submissionMediator.getSubmissionById(submissionId),
            logAction = uiPerformanceLoggerConstant.CHANGE_PRODUCTS,
            message = submissionId.toString(),
            productShortNames = submission.productShortNames,
            modalInstance = $uibModal.open({
                templateUrl: '/wizard/changeProducts/changeProductsModal.tpl.html',
                controller: 'changeProductsModalController',
                backdrop: 'static',
                windowClass: 'changeProductsModal',
                resolve: {
                    options: function () {
                        return {
                            selectedProducts: productShortNames,
                            submissionId: submissionId
                        };
                    }
                }
            });

        modalInstance.result.then(function (response) {
            if (response.isProductRemoved) {
                modalUtil.showConfirmationModal(submissionId, null/*quoteId*/, null/*notificationName*/, 'submission.wizard.reasonModal.changeProductsWarningModal',
                    null, /*hideLoadingBar*/false, handleClose);

                function handleClose() {
                    handleResults(response.productShortNames);
                }

            }else{
                handleResults(response.productShortNames);
            }
        });
        function handleResults(productShortNames) {
            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
            loadingBarHandler.showLoadingBar('submission.wizard.changeProductsModal.loadingBar');
            let promise = actionsMediator.changeProducts(submissionId, productShortNames).then(onSuccess, onError);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            function onSuccess() {
                loadingBarHandler.hideLoadingBar();
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
            }

            function onError() {
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
            }
        }

    };

    this.updateStatusReason = function (submissionId) {
        const submission = submissionMediator.getCurrentSubmission(),
            reason = {
                reason: submission.statusReason,
                details: submission.statusDetail
            };

        umModalUtil.showReasonModal(submissionId, null/*quoteId*/, null/*notification.decline*/, reason, 'submission.wizard.reasonModal.updateStatusReasonModal', false,
            uiPerformanceLoggerConstant.UPDATE_STATUS_REASON, handleClose);

        function handleClose(result) {
            loadingBarHandler.showLoadingBar('submission.wizard.reasonModal.updateStatusReasonModal.loadingBar');
            let promise = actionsMediator.updateStatusReason(submissionId, result.reason, result.details);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.submitApplication = function (submissionId) {
        let doSubmit = () => {
            let onSuccess = () => {
                loadingBarHandler.hideLoadingBar();
                let logAction = uiPerformanceLoggerConstant.SUBMIT_SUBMISSION,
                    status = coreConstant.uiPeformanceLogger.SUCCESS;
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
            };

            let onError = () => {
                let logAction = uiPerformanceLoggerConstant.SUBMIT_SUBMISSION,
                    status = coreConstant.uiPeformanceLogger.FAIL;
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
            };
            let promise;

            loadingBarHandler.showLoadingBar('submission.submittingApplication');

            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = submissionMediator.submitSubmission(submissionId).then(onSuccess, onError);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        };

        let showSubmitModal = (notificationPopupTemplate) => {
            let options = {};
            options.title = notificationPopupTemplate.title;
            options.summary = notificationPopupTemplate.body;
            options.cancelButtonLabel = _.get(this.i18n, 'submit.cancelActionButtonLabel');
            options.confirmActionButtonLabel = _.get(this.i18n, 'submit.confirmActionButtonLabel');

            let modalInstance = $uibModal.open({
                templateUrl: '/ui/modal/modal.tpl.html',
                controller: 'modalController',
                backdrop: 'static',
                windowClass: 'genericModal',
                resolve: {
                    options: () => {
                        return options;
                    }
                }
            });

            let handleClose = () => {
                let logAction = uiPerformanceLoggerConstant.SUBMIT_SUBMISSION,
                    message = submissionId.toString();

                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
                doSubmit();
            };

            modalInstance.result.then(handleClose);
        };

        coreMediator.getNotificationPopupTemplate('notification.submitApplication', {submissionId: submissionId}).then(function (notificationPopupTemplate) {
            if (!isNotificationHidden(notificationPopupTemplate) && notificationPopupTemplate.enabled) {
                showSubmitModal(notificationPopupTemplate);
            } else {
                let logAction = uiPerformanceLoggerConstant.SUBMIT_SUBMISSION,
                    message = submissionId.toString();

                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
                doSubmit();
            }
        });


        function isNotificationHidden(notification) {
            return (
                (notification.excludeConsole === 'Producer' && appTypeConfigurationModel.isAgentConsole()) ||
                (notification.excludeConsole === 'Underwriter' && appTypeConfigurationModel.isUnderwriterWorkstation())
            );
        }
    };

    this.makeApplication = function (submissionId) {
        const logAction = uiPerformanceLoggerConstant.MAKE_SUBMISSION,
            message = submissionId.toString();
        let promise;
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
        $rootScope.$broadcast(coreConstant.event.START_MAKING_APPLICATION);
        loadingBarHandler.showLoadingBar('submission.creatingSubmission');

        function onSuccess(response) {
            loadingBarHandler.hideLoadingBar();
            if (response.originator !== submissionConstant.originator.UPLOAD_ACORD_PDF) {
                submissionMediator.updateOpenSubmission(response);
                $state.go('submission.default', {submissionId: submissionId}, {reload: true});

            } else {
                $rootScope.$broadcast(coreConstant.event.CLOSE_SUBMISSION_VIEW, submissionId);
            }
            const logAction = uiPerformanceLoggerConstant.MAKE_SUBMISSION,
                status = coreConstant.uiPeformanceLogger.SUCCESS;
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
        }

        function onError() {
            const logAction = uiPerformanceLoggerConstant.MAKE_SUBMISSION,
                status = coreConstant.uiPeformanceLogger.FAIL;
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
            loadingBarHandler.hideLoadingBar();
        }

        promise = actionsMediator.makeApplication(submissionId).then(onSuccess, onError);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.delete = function (submissionId) {
        modalUtil.showConfirmationModal(submissionId, null/*quoteId*/, null/*notificationName*/, 'submission.wizard.deleteSubmissionModal',
            null/*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            let promise = submissionMediator.deleteSubmission(submissionId);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.deletePreDraft = function (submissionId) {
        let promise = submissionMediator.deleteSubmission(submissionId);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.modifySubmission = function (submissionId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.modifyingSubmission');

        promise = actionsMediator.modifySubmission(submissionId).then(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);

            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.handleAssignAccount = function (submission) {
        $uibModal.open({
            templateUrl: '/account/assign/assignAccountModal.tpl.html',
            controller: 'assignAccountModalController',
            backdrop: 'static',
            windowClass: 'assignAccountModal',
            resolve: {
                submission: function () {
                    return submission;
                }
            }
        });
    };

    this.referSubmission = function (submissionId) {
        const submission = submissionMediator.getCurrentSubmission(),
            dropdownFilterFunctions = {
                secondaryDropdown: referralUnderwriterFilterFunction
            };

        function referralUnderwriterFilterFunction(referralUnderwriter) {
            return _.toInteger(referralUnderwriter.value) !== submission.responsibleUnderwriterSummary.id;
        }

        umModalUtil.showReasonModal(submissionId, null/*quoteId*/, null/*notification.decline*/, null /*reasonObject*/, 'submission.wizard.reasonModal.referModal', false,
            uiPerformanceLoggerConstant.REFER_SUBMISSION, handleClose, dropdownFilterFunctions, false);

        function handleClose(result) {
            loadingBarHandler.showLoadingBar('submission.wizard.reasonModal.referModal.loadingBar');
            let promise = actionsMediator.referSubmission(submissionId, result.reason, result.secondaryReason.value, result.details);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.retractReferral = function (submissionId) {
        umModalUtil.showReasonModal(submissionId, null/*quoteId*/, null, null /*reason*/, 'submission.wizard.reasonModal.retractReferralModal', false,
            uiPerformanceLoggerConstant.RETRACT_REFERRAL, handleClose);

        function handleClose(result) {
            let promise = actionsMediator.retractReferral(submissionId, result.reason, result.details);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.clearReferral = function (submissionId) {
        actionsMediator.getReferralClearanceType(submissionId).then((responseData) => {
            const clearanceType = responseData.clearanceType,
                options = {};

            options.primaryAction = clearanceType === 'clear' ? _.get(this.i18n, 'clearReferralModal.clearReferralAction') : _.get(this.i18n, 'clearReferralModal.partiallyClearReferralAction');
            options.primaryActionLoadingBar = clearanceType === 'clear' ? _.get(this.i18n, 'clearReferralModal.clearingReferralLoadingBar') : _.get(this.i18n, 'clearReferralModal.partiallyClearingReferralLoadingBar');
            options.showSecondaryAction = false;
            options.summary = null;

            function handleClose(result) {
                if (result.primaryAction) {
                    let promise = actionsMediator.clearReferral(submissionId, result.comments, false/*doDecline*/).then(() => {
                        if (clearanceType === 'partiallyClear') {
                            this.referSubmission(submissionId);
                        }
                    });
                    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                    return promise;
                }
            }

            modalUtil.showCommentsModal(
                submissionId,
                null/*comments*/,
                options,
                'submission.wizard.commentsModal.clearReferralModal',
                uiPerformanceLoggerConstant.CLEAR_REFERRAL,
                handleClose.bind(this));
        });
    };

    this.rewriteSubmission = function (submissionId) {
        const modalInstance = $uibModal.open({
            templateUrl: '/wizard/rewriteSubmission/rewriteSubmissionModal.tpl.html',
            controller: 'rewriteSubmissionModalController',
            backdrop: 'static',
            windowClass: 'rewriteSubmissionModal',
            resolve: {
                submissionId: () => {
                    return submissionId;
                }
            }
        });

        modalInstance.result.then((response) => {
            const logAction = uiPerformanceLoggerConstant.REWRITE_SUBMISSION,
                message = `${submissionId} - ${response.copyOptions}`;

            function onSuccess(response) {
                submissionMediator.loadSubmission(response.id).then(function (submission) {
                    loadingBarHandler.hideLoadingBar();
                    submissionMediator.setCurrentSubmission(submission);
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
                });
            }

            function onError() {
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
            }

            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
            loadingBarHandler.showLoadingBar(this.i18n.rewriteSubmission.loadingBar);
            actionsMediator.rewriteSubmission(submissionId, response.reason, response.details, response.startDate, response.endDate, response.copyOptions).then(onSuccess, onError);
        });
    };

    this.resubmitSubmission = function (submissionId) {
        modalUtil.showConfirmationModal(submissionId, null/*quoteId*/, null/*notificationName*/, 'submission.wizard.reasonModal.resubmitModal',
            uiPerformanceLoggerConstant.RESUBMIT_SUBMISSION, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            function onSuccess(response) {
                $state.go('submission.form', {submissionId: response.id});
            }

            let promise = actionsMediator.resubmitSubmission(submissionId).then(onSuccess);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.submitRenewal = function (submissionId) {
        modalUtil.showConfirmationModal(submissionId, null/*quoteId*/, null/*notificationName*/, 'submission.wizard.reasonModal.submitRenewalModal',
            uiPerformanceLoggerConstant.SUBMIT_RENEWAL, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            function onSuccess(response) {
                $state.go('submission.form', {submissionId: response.id});
            }

            let promise = actionsMediator.submitRenewal(submissionId).then(onSuccess);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.submitNonRenewal = function (submissionId) {
        umModalUtil.showReasonModal(submissionId, null/*quoteId*/, 'notification.submitNonRenewal', null /*reason*/, 'submission.wizard.reasonModal.submitNonRenewalModal', false,
            uiPerformanceLoggerConstant.SUBMIT_NON_RENEWAL, handleClose);

        function handleClose(result) {
            let promise = actionsMediator.submitNonRenewal(submissionId, result.reason, result.details);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.retractNonRenewal = function (submissionId) {
        modalUtil.showConfirmationModal(submissionId, null/*quoteId*/, null/*notificationName*/, 'submission.wizard.reasonModal.retractNonRenewalModal',
            uiPerformanceLoggerConstant.RETRACT_NON_RENEWAL, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            let promise = actionsMediator.retractNonRenewal(submissionId);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.flagForNonRenewal = function (submissionId) {
        umModalUtil.showReasonModal(submissionId, null/*quoteId*/, 'notification.flagForNonRenewal', null /*reason*/, 'submission.wizard.reasonModal.flagforNonRenewalModal', false,
            uiPerformanceLoggerConstant.FLAG_FOR_NON_RENEWAL, handleClose);

        function handleClose(result) {
            let promise = actionsMediator.flagForNonRenewal(submissionId, result.reason, result.details);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.clearNonRenewalFlag = function (submissionId) {
        modalUtil.showConfirmationModal(submissionId, null/*quoteId*/, null/*removed'notification.clearNonRenewalFlag'*/, 'submission.wizard.reasonModal.clearFlagforNonRenewalModal',
            uiPerformanceLoggerConstant.CLEAR_NON_RENEWAL_FLAG, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            let promise = actionsMediator.clearNonRenewalFlag(submissionId);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.disableAutomation = function (submissionId) {
        modalUtil.showConfirmationModal(submissionId, null/*quoteId*/, null/*notificationName*/, 'submission.wizard.reasonModal.disableAutomationModal',
            uiPerformanceLoggerConstant.DISABLE_AUTOMATION, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            let promise = actionsMediator.disableAutomation(submissionId);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.openDetailedHistory = function (submission) {
        $uibModal.open({
            templateUrl: '/detailedHistory/detailedHistoryModal.tpl.html',
            controller: 'detailedHistoryModalController',
            backdrop: 'static',
            windowClass: 'detailedHistoryModal',
            resolve: {
                submission: () => {
                    return submission;
                },
                options: () => {
                    return {
                        title: _.get(this.i18n, 'detailedHistory.title'),
                        isReadOnly: true
                    };
                }
            }
        });
    };

    this.startPrequalification = function (submissionId, preDraft) {
        if (!preDraft) {
            loadingBarHandler.showLoadingBar('submission.prequalifyingStarting');
        }
        $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_START_LOADING);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        let promise = submissionPrequalificationMediator.startPrequalification(submissionId)
            .then(function (submission) {
                $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_CHANGE_FORM_ID, submission);
            })
            .finally(function () {
                loadingBarHandler.hideLoadingBar();
                $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_STOP_LOADING);
            });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.cancelPrequalification = function (submissionId, preDraft) {
        if (!preDraft) {
            loadingBarHandler.showLoadingBar('submission.prequalifyingCancelled');
        }
        $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_START_LOADING);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        let promise = submissionPrequalificationMediator.cancelPrequalification(submissionId)
            .then(function (submission) {
                $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_CHANGE_FORM_ID, submission);
            })
            .finally(function () {
                loadingBarHandler.hideLoadingBar();
                $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_STOP_LOADING);
            });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.submitPrequalification = function (submissionId) {
        loadingBarHandler.showLoadingBar('submission.creatingSubmission');
        $rootScope.$broadcast(coreConstant.event.START_MAKING_APPLICATION);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        let promise = submissionPrequalificationMediator.submitPrequalification(submissionId).then(function (submissionSummary) {
            $rootScope.$broadcast(coreConstant.event.CLOSE_SUBMISSION_VIEW, submissionId);
            if (submissionSummary.originator !== submissionConstant.originator.UPLOAD_ACORD_PDF) {
                const params = {submissionId: submissionId},
                    stateName = 'submission.default',
                    reload = true;
                $state.go(stateName, params);
            }
        }).finally(function () {
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.checkPrequalification = function (submissionId, preDraft) {
        if (!preDraft) {
            loadingBarHandler.showLoadingBar('submission.prequalifyingSubmission');
        }
        $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_START_LOADING);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        let promise = submissionPrequalificationMediator.checkPrequalification(submissionId)
            .then(function (submission) {
                $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_CHANGE_FORM_ID, submission);
            })
            .finally(function () {
                loadingBarHandler.hideLoadingBar();
                $rootScope.$broadcast(submissionConstant.event.PREQUALIFICATION_STOP_LOADING);
            });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.markExpired = function (submissionId) {
        umModalUtil.showReasonModal(submissionId, null/*quoteId*/, null/*notificationName*/, null /*reason*/, 'submission.wizard.reasonModal.markExpiredModal', false,
            uiPerformanceLoggerConstant.MARK_EXPIRED, handleClose);

        function handleClose(result) {
            let promise = actionsMediator.markExpired(submissionId, result.reason, result.details);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.markNonRenewed = function (submissionId) {
        umModalUtil.showReasonModal(submissionId, null/*quoteId*/, null/*notificationName*/, null /*reason*/, 'submission.wizard.reasonModal.markNonRenewedModal', false,
            uiPerformanceLoggerConstant.MARK_NON_RENEWED, handleClose);

        function handleClose(result) {
            let promise = actionsMediator.markNonRenewed(submissionId, result.reason, result.details);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.markRenewed = function (submissionId) {
        modalUtil.showConfirmationModal(submissionId, null/*quoteId*/, null/*notificationName*/, 'submission.wizard.reasonModal.markRenewedModal',
            uiPerformanceLoggerConstant.MARK_RENEWED, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            let promise = actionsMediator.markRenewed(submissionId);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };
    this.declineReferral = function (submissionId) {
        let options = {
            showSecondaryAction: false,
            summary: null
        };

        modalUtil.showCommentsModal(submissionId, null/*comments*/, options, 'submission.wizard.commentsModal.declineReferralModal', uiPerformanceLoggerConstant.DECLINE_REFERRAL, handleClose);

        function handleClose(result) {
            let promise = actionsMediator.declineReferral(submissionId, result.comments);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };
};

angular.module('gw-um-submission')
    .service('submissionActionUtil', SubmissionActionUtil);
